import { Outlet } from 'react-router-dom';

import { ADMIN_PATH, AdminLayout } from '@/features/admin';
import { GuardSynapsAdmin } from '@/features/auth/GuardSynapsAdmin';

export function AdminSynapsAdminAuthenticatedLayout() {
  return (
    <GuardSynapsAdmin loginPath={`${ADMIN_PATH}/login`}>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </GuardSynapsAdmin>
  );
}
